/* eslint-disable-off functional/no-return-void */
import {
  Form as FForm,
  Formik,
  FormikConfig,
  FormikContextType,
  FormikValues,
} from 'formik';
import React, { FC } from 'react';
import { Card, Form, Spinner } from 'react-bootstrap';
import LoadingOverlay from '@achmadk/react-loading-overlay';

import { FormFooter, FormHeader } from './';

type Props<T = { readonly [key: string]: any }> = FormikConfig<T> & {
  readonly isNew?: boolean;
  readonly title: any;
  readonly idx?: number;
  readonly border?:
    | 'light'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'dark';
  readonly permitDelete?: boolean;
  readonly permitSubmit?: boolean;
  readonly onReturn?: () => void;
  readonly onDelete?: () => void;
  readonly actions?: React.ReactNode; // i.e. Custom Buttons
  readonly loading?: boolean;
  readonly loadingText?: boolean;
  readonly noButtons?: boolean;
  readonly alwaysOn?: boolean;
  readonly injectFooterElements?: (
    formikCtx: FormikContextType<FormikValues>
  ) => React.ReactNode;
  /**  Optional Header Buttons */
  readonly injectHeaderElements?: () => React.ReactNode;
  readonly onCancel?: () => void;
};

const FormCard: FC<Props> = ({
  isNew,
  title,
  idx = null,
  border = null,
  permitDelete = false,
  onReturn,
  onDelete = null,
  actions = null,
  loading = false,
  loadingText = 'Παρακαλώ περιμένετε...',
  children = null,
  permitSubmit = false,
  noButtons = false,
  alwaysOn = false,
  injectFooterElements,
  injectHeaderElements,
  onCancel = null,
  ...rest // εδω περνάς το onSubmit, validate, ...
}) => {
  const validationSchema = rest.validationSchema;
  const initialValues = rest.initialValues;

  // clone children to pass validationSchema/initialValues prop down if they expect it
  // Handle function children (render props) separately
  const patchedChildren =
    typeof children === 'function'
      ? children
      : React.Children.map(children as React.ReactNode, (child) =>
          React.isValidElement(child)
            ? typeof child.type === 'string'
              ? child
              : React.cloneElement(child as React.ReactElement, {
                  validationSchema,
                  initialValues,
                })
            : child
        );

  return (
    <LoadingOverlay active={loading} spinner text={loadingText}>
      <Formik
        {...rest}
        validationSchema={validationSchema}
        initialValues={initialValues || {}}
      >
        {(formikProps) => {
          return (
            <>
              {/* First Form */}
              <Form as={FForm}>
                <Card
                  className="shadow m-a"
                  border={border || undefined}
                  bg="light"
                >
                  <FormHeader
                    title={
                      loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        title
                      )
                    }
                    idx={idx}
                    onReturn={onReturn}
                    injectHeaderElements={injectHeaderElements}
                  />
                  <Card.Body>{patchedChildren as any}</Card.Body>
                  <FormFooter
                    disabled={permitSubmit}
                    isNew={isNew}
                    permitDelete={permitDelete}
                    onDelete={onDelete}
                    loading={loading}
                    noButtons={noButtons}
                    alwaysOn={alwaysOn}
                    injectFooterElements={injectFooterElements}
                    onCancel={onCancel}
                  >
                    {actions}
                  </FormFooter>
                </Card>
              </Form>
            </>
          );
        }}
      </Formik>
    </LoadingOverlay>
  );
};

export default FormCard;
